import React, { useState } from 'react'
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import { Divider, Grid, useMediaQuery } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { fontColorForAwaitWebhook } from '../../../../../../utils/constants';
import GlobalPopUp from '../../../../../../components/utility/globalPopUp';
import WebhookActionLogPopup from './webhookActionLogPopup';

interface AwaitWebhookActionProps {
    actionData: any,
} 

const AwaitWebhookAction: React.FC<AwaitWebhookActionProps> = (props) => {
    
    const { actionData } = props;

    const [flagOpenAwaitWebhookInPopup, setFlagOpenAwaitWebhookInPopup] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)');

    return (
        <>
            <Grid container className={`${styles.customAPIMsgMainContainer} ${styles.webhookMsgMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.alignItemCenter}`}>
                        <Grid item className={styles.customAPICallMsgTitle}>
                            <Grid container className={globalStyles.alignItemCenter} gap={"14px"}>
                                <Grid item>
                                    Await Webhook
                                </Grid>
                               <Grid item className={styles.customAPIMethod} sx={{color: actionData?.status ?  fontColorForAwaitWebhook(actionData?.status) : "black", boxShadow: `0 0 2px ${actionData?.status ? fontColorForAwaitWebhook(actionData?.status) : "black"}`}}>
                                    {actionData?.status || "-"}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={globalStyles.clickable} onClick={() => setFlagOpenAwaitWebhookInPopup(true)}>
                            <OpenInFullIcon className={styles.openInNewIconForCustomAPI} />
                        </Grid>
                    </Grid>
                </Grid>
                <Divider /> 
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} alignItems={"center"} flexWrap={"nowrap"}>
                        <Grid item xs={5.5} className={styles.customAPICallInfoTitle}>
                            Company Name
                        </Grid> 
                        <Grid item xs={6}>
                            {actionData?.webhook_external_company_name || "-"}
                        </Grid>
                    </Grid>
                </Grid>

                 <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"}>
                        <Grid item xs={5.5} className={styles.customAPICallInfoTitle}>
                            Webhook URL    
                        </Grid> 
                        <Grid item xs={6}>
                            {actionData?.expected_webhook_url || "-"}
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} alignItems={"center"} flexWrap={"nowrap"}>
                        <Grid item xs={5.5} className={styles.customAPICallInfoTitle}>
                            Status
                        </Grid>
                        <Grid item xs={6}>
                            {actionData?.status || "-"}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> 

            {flagOpenAwaitWebhookInPopup && 
                <GlobalPopUp
                    open={flagOpenAwaitWebhookInPopup}
                    handleClose={() => setFlagOpenAwaitWebhookInPopup(false)} 
                    onClose={() => setFlagOpenAwaitWebhookInPopup(false)}
                    flagShowCloseIcon={true}
                    titlePadding='0px'
                    paperMinWidth={flagSmallScreen ? "350px" : "90%"}
                    paperMaxwidth={flagSmallScreen ? "710px" : "90%"}
                >
                    <WebhookActionLogPopup
                        actionData={actionData}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default AwaitWebhookAction
